import { render, staticRenderFns } from "./extcustomerTemp.vue?vue&type=template&id=64b29245&scoped=true&"
import script from "./extcustomerTemp.vue?vue&type=script&lang=js&"
export * from "./extcustomerTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b29245",
  null
  
)

export default component.exports